import * as React from "react";
import Video from "../../../public/samplevideo.mp4";
import { useIntroSeenMutation } from "@/store/user/studentApi";
import { useSelector } from "react-redux";
import { Button } from "../ui/button";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

const UserLoginVideo = () => {
  const [showSkip, setShowSkip] = React.useState(false);
  const { user } = useSelector((state) => state.user);
  const [introSeen] = useIntroSeenMutation();

  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  React.useEffect(() => {
    const timer = setTimeout(() => setShowSkip(true), 20000);
    return () => clearTimeout(timer);
  }, []);

  const handleFinish = async () => {
    await introSeen({ Token: user?.token });
    localStorage.removeItem("showLoginVideo");
    window.location.reload();
  };

  return (
    <div
      className="fixed inset-0 z-10 bg-black/40 backdrop-blur-md
                 flex items-center justify-center overflow-hidden"
    >
      {/* Video Container */}
      <div
        className="relative w-[100%] max-w-6xl
                   max-h-[90vh]
                  sm:rounded-2xl
                   overflow-hidden shadow-2xl bg-black"
      >
        {/* Aspect Ratio Wrapper */}
        <div className="relative w-full" style={{ aspectRatio: "16 / 9" }}>
          <video
            autoPlay
            muted
            playsInline
            onEnded={handleFinish}
            className="absolute inset-0 w-full h-full object-contain"
          >
            <source src={Video} type="video/mp4" />
          </video>
        </div>

        {/* Skip Button With Dialog */}
        {showSkip && (
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button
                className="absolute top-3 right-3 sm:top-4 sm:right-4 
                           bg-black/40 text-white 
                           px-3 py-1.5 sm:px-4 sm:py-2 
                           rounded-lg font-semibold backdrop-blur-sm
                           hover:bg-black/50 transition-all"
              >
                Skip
              </Button>
            </AlertDialogTrigger>

            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle className="text-foreground">
                  Are you sure you want to skip?
                </AlertDialogTitle>
                <AlertDialogDescription>
                  The introduction video will stop and cannot be viewed again
                  automatically.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>Cancel</AlertDialogCancel>
                <AlertDialogAction onClick={handleFinish}>
                  Skip Anyway
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        )}
      </div>
    </div>
  );
};

export default UserLoginVideo;
